import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import Experience from './Experience.js'

/**
 * Camera
 * Creates a PerspectiveCamera and attaches OrbitControls.
 * Responds to resize events via resize() and advances controls via update().
 */
export default class Camera {
    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas

        this.setInstance()
        this.setControls()
    }

    setInstance() {
        this.instance = new THREE.PerspectiveCamera(
            35,
            this.sizes.width / this.sizes.height,
            0.1,
            100
        )
        // Positioned to frame the candle: slightly elevated, centered
        this.instance.position.set(0, 1.2, 7)
        this.scene.add(this.instance)
    }

    setControls() {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.target.set(0, 0.5, 0)
        this.controls.enableDamping = true
        this.controls.dampingFactor = 0.05
        // Disabled by default — GSAP takes over; re-enable in explore section
        this.controls.enabled = false
    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update() {
        this.controls.update()
    }
}
